import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as action from '../actions/about';
import { RootState } from '../reducers';
import { About } from '../../components/About/types';

export const useAboutState = () => {
  const { ...about } = useSelector((state: RootState) => state.about) as About;
  return { ...about };
};

export const useAboutDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators({ ...action }, dispatch) };
};
